import type { StaticDataRouteOption } from "@tanstack/react-router"

// Which of the shell's three screens a route shows (DESIGN.md, Screens): a
// page, the Portfolio, or Companies. Each shell route declares its own in
// `staticData`, so the shell's layout and the router's view transitions read
// one answer, and a new page is one line in its route file.
export type ShellMode = "page" | "portfolio" | "companies"

declare module "@tanstack/react-router" {
  // Module augmentation merges only into an interface.
  // eslint-disable-next-line @typescript-eslint/consistent-type-definitions
  interface StaticDataRouteOption {
    shellMode?: ShellMode
  }
}

// The deepest matched route's screen, or null outside the shell.
export const shellModeOf = (
  matches: readonly { staticData?: StaticDataRouteOption }[]
): ShellMode | null =>
  matches.findLast((match) => match.staticData?.shellMode)?.staticData
    ?.shellMode ?? null

// The view transition for a navigation from one screen to another
// (DESIGN.md, Screens › Page frame; Navigation › Header): into or out of a
// page, the well moves (`page-frame`); Portfolio to Companies, contents
// crossfade in place (`mode-switch`); within one screen, or outside the
// shell, nothing moves.
export const shellTransitionTypes = (
  from: ShellMode | null,
  to: ShellMode | null
): ["page-frame"] | ["mode-switch"] | false => {
  if (!from || !to || from === to) return false
  return from === "page" || to === "page" ? ["page-frame"] : ["mode-switch"]
}
